import { ProjectBaseState } from './project-base.model';
import { createReducer, on } from '@ngrx/store';
import { zefResetState } from '@zerops/zef/core';
import {
  loadProjectTagsSuccess,
  listVpnPublicKeysSuccess,
  loadL7HttpBalancerConfigSuccess,
  revealProjectEnvSuccess,
  hideProjectEnv,
  clearRevealedProjectEnv,
  ProjectBaseActionUnion
} from './project-base.action';

const initialState = new ProjectBaseState();

const actionReducer = createReducer(
  initialState,
  on(
    loadProjectTagsSuccess,
    (s, { data }): ProjectBaseState => ({
      ...s,
      tags: data
    })
  ),
  on(
    listVpnPublicKeysSuccess,
    (s, { data }): ProjectBaseState => ({
      ...s,
      vpnSettingsMap: {
        ...s.vpnSettingsMap,
        [data.id]: data.response
      }
    })
  ),
  on(
    loadL7HttpBalancerConfigSuccess,
    (s, { data }): ProjectBaseState => ({
      ...s,
      l7ConfigMap: {
        ...s.l7ConfigMap,
        [data.id]: data.response.values
      }
    })
  ),
  on(
    revealProjectEnvSuccess,
    (s, { data, originalAction }): ProjectBaseState => ({
      ...s,
      revealedEnvContent: {
        ...s.revealedEnvContent,
        [originalAction.data.id]: data.content
      }
    })
  ),
  on(
    hideProjectEnv,
    (s, { id }): ProjectBaseState => {
      // drop the entry from a copy - state itself is never mutated
      const revealedEnvContent = { ...s.revealedEnvContent };
      delete revealedEnvContent[id];
      return { ...s, revealedEnvContent };
    }
  ),
  on(
    clearRevealedProjectEnv,
    (s): ProjectBaseState => ({ ...s, revealedEnvContent: {} })
  ),
  on(zefResetState, () => initialState)
);

export function projectBaseReducer(
  state: ProjectBaseState,
  action: ProjectBaseActionUnion
) {
  return actionReducer(state, action);
}
